<script setup lang="ts">
import VueMarkdown from 'vue-markdown-render';

const props = defineProps<{
  themeKeys: {
    title: string;
    subtitle: string;
    bg: string;
    stats: string;
    description: string;
    afterText: string;
    smallPrint: string;
  };
  stats: {
    title: string;
    subtitle: string;
    stats: Record<
      string,
      {
        stat: string;
        text: string;
      }
    >;
    text: string;
    smallPrint: string;
  };
}>();
</script>

<template>
  <div
    class="outer-p-container"
    :style="{
      backgroundColor: props.themeKeys.bg,
    }"
  >
    <div class="inner-container">
      <h3
        :style="{
          color: props.themeKeys.title,
        }"
        class="text-center font-semibold text-3xl lg:text-4xl mb-2 lg:mb-4"
      >
        {{ props.stats.title }}
      </h3>
      <h4
        :style="{
          color: props.themeKeys.subtitle,
        }"
        class="text-center mb-12 lg:mb-20 w-2/3 mx-auto"
      >
        {{ props.stats.subtitle }}
      </h4>
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-12 justify-between mx-4 lg:mx-12 mb-12 lg:mb-20">
        <div
          v-for="stat in Object.values(props.stats.stats)"
          class="text-center"
        >
          <div
            class="text-2xl font-semibold mb-2"
            :style="{
              color: props.themeKeys.stats,
            }"
          >
            {{ stat.stat }}
          </div>
          <div
            :style="{
              color: props.themeKeys.description,
            }"
          >
            {{ stat.text }}
          </div>
        </div>
      </div>
      <div class="mx-4 lg:mx-12">
        <p
          class="mb-12"
          :style="{
            color: props.themeKeys.afterText,
          }"
        >
          {{ props.stats.text }}
        </p>
        <p
          class="text-xs"
          :style="{
            color: props.themeKeys.smallPrint,
          }"
        >
          <VueMarkdown :source="props.stats.smallPrint" :options="{ html: true }" />
        </p>
      </div>
    </div>
  </div>
</template>
